// extracted by css-extract-rspack-plugin
export default {"root":"root-gOoKOk","loader":"loader-UOoN6t"};